import { Lock } from '@/components/Lock';
import { TPage } from '@/types';
import { Flag, Typography } from '@data-products-and-ai/react-components';

const Countries = ({ team, target }: TPage) => {
  return (
    <Lock
      target={target}
      lockType="letter"
      combination="PWCP"
      text={
        <>
          <Typography>
            Today we spend the day in sunny Lisbon but we are no ordinary
            cats...
            <br />
            <br />
            We frequently travel and we have a lot of cat friends all over the
            world.
            <br />
            <br />
            Find the pattern to solve the puzzle!
          </Typography>
          <div
            style={{
              marginTop: 30,
              display: 'grid',
              gridTemplateColumns: '1fr 1fr 1fr',
            }}
          >
            <Typography tag="h3">
              <Flag flag="de" width={30} /> = B
            </Typography>
            <Typography tag="h3">
              <Flag flag="es" width={30} /> = M
            </Typography>
            <Typography tag="h3">
              <Flag flag="gb" width={30} /> = L
            </Typography>
            <Typography tag="h3">
              <Flag flag="ua" width={30} /> = K
            </Typography>
            <Typography tag="h3">
              <Flag flag="ar" width={30} /> = B
            </Typography>
            <Typography tag="h3">
              <Flag flag="no" width={30} /> = O
            </Typography>
          </div>
          <div
            style={{
              display: 'flex',
              marginTop: 50,
              gap: 20,
              alignContent: 'center',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <div style={{ border: 'solid 1px #666666' }}>
              <Flag flag="fr" width={60} />
            </div>
            <div style={{ border: 'solid 1px #666666' }}>
              <Flag flag="us" width={60} />
            </div>
            <div style={{ border: 'solid 1px #666666' }}>
              <Flag flag="dk" width={60} />
            </div>
            <div style={{ border: 'solid 1px #666666' }}>
              <Flag flag="cz" width={60} />
            </div>
          </div>
        </>
      }
    />
  );
};

export default Countries;
